import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { StyledAccordion, AccordionHeader, AccordionContent } from './Accordion.style';
import ChevronDown from '../../../assets/icons/ChevronDown';
import Avatar from "../Avatar/Avatar";
export const Accordion = ({ label, items = [], children, className, disabled, defaultOpenAll = false, defaultOpenFirstOnly = false, }) => {
    const [openItems, setOpenItems] = useState(() => {
        if (defaultOpenFirstOnly && items.length > 0) {
            return ["item-0"];
        }
        if (!defaultOpenAll)
            return [];
        const keys = items.map((_, index) => `item-${index}`);
        if (label)
            keys.unshift("main");
        return keys;
    });
    const toggleItem = (key) => {
        if (!disabled) {
            setOpenItems((prev) => prev.includes(key)
                ? prev.filter((item) => item !== key)
                : [...prev, key]);
        }
    };
    const isExpanded = (key) => openItems.includes(key);
    return (_jsxs(StyledAccordion, { className: `cmp-accordion ${className || ""}`, disabled: disabled, "data-cmp-is": "accordion", children: [label && (_jsxs("div", { className: "cmp-accordion__item", children: [_jsxs(AccordionHeader, { className: "accordion-header", onClick: () => toggleItem("main"), isOpen: isExpanded("main"), disabled: disabled, "aria-expanded": isExpanded("main"), children: [_jsx("span", { children: label }), _jsx(ChevronDown, { className: isExpanded("main") ? "open" : "", "aria-hidden": "true", iconSize: "16px" })] }), _jsx(AccordionContent, { isOpen: isExpanded("main"), children: children })] })), items.map((item, index) => (_jsxs("div", { className: "cmp-accordion__item", children: [_jsxs(AccordionHeader, { onClick: () => toggleItem(`item-${index}`), isOpen: isExpanded(`item-${index}`), disabled: disabled, "aria-expanded": isExpanded(`item-${index}`), children: [item.image && (_jsx(Avatar, { aspectRatio: "4:3", width: 40, height: 40, imageUrl: item.image })), _jsx("span", { children: item.label }), _jsx(ChevronDown, { className: isExpanded(`item-${index}`) ? "open" : "", "aria-hidden": "true", iconSize: "16px" })] }), _jsx(AccordionContent, { isOpen: isExpanded(`item-${index}`), children: item.content })] }, index)))] }));
};
export default Accordion;
//# sourceMappingURL=Accordion.js.map